"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The MetricLatest model module.
 * @module model/MetricLatest
 * @version 0.2.0
 */
var MetricLatest = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MetricLatest</code>.
   * @alias module:model/MetricLatest
   */
  function MetricLatest() {
    _classCallCheck(this, MetricLatest);

    MetricLatest.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(MetricLatest, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>MetricLatest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MetricLatest} obj Optional instance to populate.
     * @return {module:model/MetricLatest} The populated <code>MetricLatest</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MetricLatest();

        if (data.hasOwnProperty('ts')) {
          obj['ts'] = _ApiClient["default"].convertToType(data['ts'], 'String');
        }

        if (data.hasOwnProperty('value')) {
          obj['value'] = _ApiClient["default"].convertToType(data['value'], 'Number');
        }

        if (data.hasOwnProperty('change')) {
          obj['change'] = _ApiClient["default"].convertToType(data['change'], 'Number');
        }
      }

      return obj;
    }
  }]);

  return MetricLatest;
}();
/**
 * @member {String} ts
 */


MetricLatest.prototype['ts'] = undefined;
/**
 * @member {Number} value
 */

MetricLatest.prototype['value'] = undefined;
/**
 * @member {Number} change
 */

MetricLatest.prototype['change'] = undefined;
var _default = MetricLatest;
exports["default"] = _default;